"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _core = require("@material-ui/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../theme");
var _templateObject; // @ts-nocheck
// Adding this ^ because we cannot alter
// Our theme.js right now as it is heavily
// Used by OperatorPortal
var palette = _theme.theme.palette,
  spacing = _theme.theme.spacing;
var Styled = (0, _styledComponents["default"])(_core.FormControl)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .form-control {\n    margin-bottom: 16px;\n\n    label {\n      color: ", ";\n      ", "\n    }\n\n    label {\n      font-size: 16px;\n      padding-left: 4px;\n    }\n\n    .helper-text {\n      margin: ", ";\n      height: 0;\n    }\n\n    > div {\n      div {\n        background-color: #F5F8FA;\n        border-bottom: ", ";\n        ", "\n        &:hover, {\n          ", "\n        }\n\n        &::before {\n          content: none;\n        }\n        &::after {\n          content: none;\n        }\n      }\n\n      input {\n        padding: ", ";\n        font-size: 16px;\n        letter-spacing: 0.16px;\n        ", "\n      }\n\n      .MuiInputAdornment-positionStart {\n        padding: 0px 4px;\n      }\n\n      .MuiInputAdornment-positionStart,\n      .MuiInputAdornment-positionEnd {\n        margin-top: 12px;\n        border: none;\n      }\n\n      textarea {\n        padding-left: 4px;\n      }\n    }\n\n    p {\n      height: 19px;\n      display: content;\n      margin: ", ";\n    }\n  }\n"])), function (props) {
  var labelColor = '#002B39';
  if (props.error) labelColor = props.error.main;
  if (!props.value || !props.displayValue) labelColor = '#888888';
  return labelColor;
}, function (props) {
  return props.endAdornment && '';
}, "".concat(spacing() / 4, "px ").concat(spacing(2), "px"), function (props) {
  return props.disabled ? '0px solid' : '1px solid #6F878F';
}, function (props) {
  return (props.error || props.editing) && "border-bottom: 2px solid ".concat(props.error ? palette.error.main : palette.primary[700], ";");
}, function (props) {
  return !props.disabled && !props.editing && 'background-color: rgb(222, 229, 234);';
}, "".concat(spacing(3), "px ").concat(spacing(2), "px ").concat(spacing(1.5), "px"), function (props) {
  return props.disabled ? 'color: #626262' : 'color: #1E1E1E';
}, "".concat(spacing() / 2, "px ").concat(spacing(2), "px"));
exports.Styled = Styled;